module.exports = __webpack_public_path__ + "static/media/COSCO.7351607e.svg";